import { useEffect, useState } from 'react';
import { waitForElement } from '../utils/dom';

export const useWaitForElement = (selector: string, timeout?: number) => {
  const [isWaiting, setIsWaiting] = useState(true);
  const [element, setElement] = useState<Element | null>(null);

  useEffect(() => {
    setIsWaiting(true);
    setElement(null);

    waitForElement(selector, timeout).then((foundElement) => {
      setElement(foundElement);
      setIsWaiting(false);
    });
  }, [selector, timeout]);

  return {
    isWaiting,
    isReady: !isWaiting && element !== null,
    element,
  };
};
